import React, {useContext} from "react";
import { ViewportContext } from '../../context/ViewPort';
import { useStaticQuery, graphql } from "gatsby";
import PropTypes from "prop-types";
import {defaultSettings} from "../../modules/slider/sliderSettings"
import {default as ReactSlider} from "react-slick";

import HtmlBlock from "../../components/htmlBlock/htmlBlock";
import HubSpotContent from "../../components/form/hubspotFormContent/hubspotFormContent";
import Image from "../../components/image/image";
import Link from "../../components/link/link";
import NavigationBlock from "../../components/navigationBlock/navigationBlock";
import RenderNav from "../../lib/renders/renderNav";

/**
 * Footer
 * 
 */
const Footer = ({footertext, locale, ...other}) => {
  const { screenSize } = useContext(ViewportContext);

  const settings = {
    arrows: true,
    className: "footer__awards footer__row",
    slidesToScroll: 1,
    variableWidth: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 1000,
    ...defaultSettings
  };

  const { allDatoCmsGlobalFooter : footer } = useStaticQuery(
    graphql`
      query {
        allDatoCmsGlobalFooter {
          nodes{ 
            awards{
              gatsbyImageData(width: 100)
              url
              height
              width
            }
            contactInformation
            hubspotForm{
              ...HubspotContentFragment
            }
            legalLinks{
              ...LinkFragment
            }
            locale
            logo{
              ...LogoFragment
            } 
            mobileOnlyNavigation{
              ...LinkFragment
            }
            navigationColumns{
              __typename
              ...LinkCollectionFragment
            }
            socialLinks{
              ...ImageLinkFragment
            }
          }
        }
      }`
    );

  const {awards, contactInformation, hubspotForm, legalLinks, logo, mobileOnlyNavigation, navigationColumns, socialLinks} = footer.nodes.filter(item => item.locale === locale)[0] || {};

  return (
    <footer className="footer" {...other}>
      <div className="container">
        {
          footertext && screenSize !== 'mobile' && 
          <HtmlBlock data={footertext} className="footer__text tablet-min" />
        }

        <div className="footer__row">
        {
          logo && 
          <Link data={{slug: '/'}} className="tablet-min logo" icon={false} aria-label="Home">
            <Image alt="75F logo" data={logo} height={50} width={144}/>
          </Link>
        }
        <HubSpotContent loadonscroll={true} mobileButtonClass={`btn--primary--inverse`} className="footer__signup" uniqueid={'footerForm--desktop'} data={hubspotForm} />
      </div>

        {
          screenSize !== 'mobile' &&
          <>
            <ReactSlider {...settings} className="tablet-min">
              {
                awards?.map((block, key) => (
                  <div className="footer__awards__single" key={key}>
                      <Image
                        decorative={false} 
                        data={block} 
                      />
                  </div>
                ))
              }
            </ReactSlider>
          </>
        }
        
        <div className="footer__row--navigation">

          {
            screenSize === 'mobile' ? 
            <div className="footer__navCols mobile">
              <NavigationBlock data={mobileOnlyNavigation} icon={false}/>
            </div>
            :
            <div className="footer__navCols tablet-min">
              <RenderNav data={navigationColumns} icon={false}/>
            </div>
          }
        
          <HtmlBlock data={contactInformation} className="footer__contact"/>
          <div className="footer__legals tablet-min">Copyright ©{new Date().getFullYear()} 75F  
            <NavigationBlock data={legalLinks} icon={false} linkclass="footer__legals__link" />
          </div>
          <div className="footer__social">
            <NavigationBlock data={socialLinks} />
          </div>
          <div className="footer__legals mobile">
            Copyright ©{new Date().getFullYear()} 75F  
          </div>
        </div>
        
      </div>
    </footer>
  );
};

Footer.propTypes = {
  /**
   * Optional footer text from cms
   */
  footerText: PropTypes.string,
  /**
   * Current locale
   */
  locale: PropTypes.string.isRequired
}

export default Footer;
